import { useMutation, useQuery } from '@tanstack/react-query';
import { store } from '../..';
import { queryClient } from '../../..';
import { setAlert, setIsLoading } from '../../components/components-slice';
import { nhfApis } from './../../../api/payroll/statutory-compliance/nhf';

export function useGetNhfHistory(limit, page, statusFilter, search) {
  return useQuery(
    ['nhf', { limit, page, statusFilter, search }],
    () => {
      store.dispatch(setIsLoading(true));
      return nhfApis.getNHF({
        limit,
        page,
        statusFilter,
        search,
      });
    },
    {
      select(data) {
        data?.data?.forEach((nhf) => {
          nhf.status = parseFloat(nhf.nhf_status)
          if (nhf.status === 2) {
            nhf.status = 0
          }
          switch (nhf.status) {
            case 0:
              nhf.computedActions = [0];
              break;
            case 1:
              nhf.computedActions = [1];
              break;
            default:
              break;
          }
        });

        return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
      // keepPreviousData: true
    },
  );
}

export function useUploadNHF() {
  return useMutation(
    (payload) => {
      return nhfApis.bulkNHF(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('nhf');
        store.dispatch(setAlert(true, 'success', 'Upload Successful'));
      },
    },
  );
}

export function useRefNHF(payload) {
  return useQuery(
    ['nhf-by-ref', { payload }],
    () => {
      store.dispatch(setIsLoading(true));
      return nhfApis.fetchNHFByRef(payload);
    },
    {
      select: (data) => {
        // data.data.salaries.data.forEach((item) => {
        //   item.employeeName = `${item.employee_first_name} ${item.employee_last_name}`;
        //   item.net_pay = item.net_pay.toFixed(2);
        //   item.total = (
        //     parseFloat(item.trans_cost) + parseFloat(item.net_pay)
        //   ).toFixed(2);
        // });

        // return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
      // keepPreviousData: true
    },
  );
}